;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('SidebarSecondLevelMenuController', sidebarSecondLevelMenuController)

  /* @ngInject */
  function sidebarSecondLevelMenuController ($scope, $rootScope) {
    $rootScope.isSecondLevelSidebarExpanded = true

    const api = {
      _handleSidebarTransition
    }
    this.getApi = () => api

    $scope.openSidebarMobile = function () {
      api._handleSidebarTransition()
    }

    $scope.closeSidebarMobile = function () {
      api._handleSidebarTransition()
    }

    $scope.toggleCollapseSecondLevelMenu = function () {
      $rootScope.isSecondLevelSidebarExpanded = !$rootScope.isSecondLevelSidebarExpanded
    }

    function _handleSidebarTransition () {
      $('.sidebar-menu-second-level').transition('slide down')
    }
  }
})()
